import React from "react";
import { ThemeProvider } from "styled-components";
import { createTheme } from "@mui/material";
import GlobalStyles from "./components/styled/Global";
import napaTheme from "./theme/napatheme";
import { Route, Routes } from "react-router-dom";
import NewUpload from "./pages/NewUpload";
import ReqModel from "./pages/ReqModel";
import ProcessedFiles from "./pages/ProcessedFiles";
import Users from "./pages/sections/Users";
import Models from "./pages/Models";
import ModelPermissions from "./pages/ModelPermissions";
import ActivityLog from "./pages/ActivityLog";
import Login from "./pages/Login";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import NotFound from "./pages/NotFound";
import NewLandingHome from "./pages/NewLandingHome";
import WebMap from "./pages/WebMap";
import UserManagement from "./pages/UserManagement";
import Dashboard from "./pages/Dashboard";

const theme = createTheme(napaTheme);

function App() {

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <ToastContainer closeOnClick autoClose={10000} />
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/new-upload" element={<NewUpload />} />
        <Route path="/home" element={<NewLandingHome />} />
        <Route path="/req-models" element={<ReqModel />} />
        <Route path="/processed-files" element={<ProcessedFiles />} />
        <Route path="/users" element={<UserManagement />} />
        <Route path="/models" element={<Models />} />
        <Route path="/model-permissions" element={<ModelPermissions />} />
        <Route path="/activity-log" element={<ActivityLog />} />
        <Route path="/web-map" element={<WebMap />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </ThemeProvider>
  );
}

export default App;
